export default __webpack_public_path__ + "static/media/2090-00.897f3d85.jpg";